import {
  SET_MODALVISIBLE,
  SET_LOADING,
  CLEANUP,
  SET_UPLOADEDFILES,
  SET_UPLOADEDFILETYPES,
  SET_SELECTEDTYPE,
  ADD_UPLOADEDFILE,
  ADD_UPLOADEDFILETYPE,
  ADD_UPLOADEDFILENAME,
  ADD_UPLOADEDFILESIZE,
  DELETE_UPLOADEDFILE,
} from "./documentUploadType";

export const cleanup = () => {
  return {
    type: CLEANUP,
  };
};

export const setLoading = (loading) => {
  return {
    type: SET_LOADING,
    loading: loading,
  };
};

export const setModalVisible = (modalVisible) => {
  return {
    type: SET_MODALVISIBLE,
    modalVisible: modalVisible,
  };
};

export const setUploadedFiles = (uploadedFiles) => {
  return {
    type: SET_UPLOADEDFILES,
    uploadedFiles: uploadedFiles,
  };
};

export const setUploadedFileTypes = (uploadedFileTypes) => {
  return {
    type: SET_UPLOADEDFILETYPES,
    uploadedFileTypes: uploadedFileTypes,
  };
};

export const setSelectedType = (selectedType) => {
  return {
    type: SET_SELECTEDTYPE,
    selectedType: selectedType,
  };
};

export const addUploadedFile = (uploadedFile) => {
  return {
    type: ADD_UPLOADEDFILE,
    uploadedFile: uploadedFile,
  };
};

export const addUploadedFileType = (uploadedFileType) => {
  return {
    type: ADD_UPLOADEDFILETYPE,
    uploadedFileType: uploadedFileType,
  };
};

export const addUploadedFilename = (uploadedFilename) => {
  return {
    type: ADD_UPLOADEDFILENAME,
    uploadedFilename: uploadedFilename,
  };
};

export const addUploadedFileSize = (uploadedFileSize) => {
  return {
    type: ADD_UPLOADEDFILESIZE,
    uploadedFileSize: uploadedFileSize,
  };
};

export const deleteUploadedFile = (index) => {
  return {
    type: DELETE_UPLOADEDFILE,
    index: index,
  };
};